// UserSeasonCards.js
import React from "react";

const UserSeasonCards = () => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-md mb-4">
      <p>TODO Season Cards</p>
    </div>
  );
};

export default UserSeasonCards;
